import classNames from 'classnames';
import dealerDestructure from 'helpers/dealer-destructure';
import flectionNumeral from 'helpers/number';
import OfferInterface from 'interfaces/offer.interface';
import React, { useState } from 'react';

import ProductOffer from './product-offer';
import './product-offer-wrapper.scss';

const ProductOfferWrapper: React.FC<{ offer: OfferInterface; }> = ({ offer }) => {
    const {
        highlighted,
        freeDelivery,
        inPost,
        delivery24h,
        rates,
        fastPayment,
        promoText
    } = dealerDestructure(offer.dealer);
    const [isOpenVariants, setIsOpenVariants] = useState<boolean>(false);

    const onToggleOpenVariants = (): void => {
        setIsOpenVariants(!isOpenVariants);
    };

    return (
        <div className={classNames({
            'offer-wrapper': true,
            'offer-wrapper__highlighted': Boolean(highlighted)
        })}
        >
            <ProductOffer
                id={offer.id}
                shopUrl={offer.url}
                highlighted={Boolean(highlighted)}
                dealer={{
                    id: offer.dealer.id,
                    name: offer.dealer.name,
                    logo: offer.dealer.logo,
                    authorized: offer.dealer.authorized,
                    badge: offer.dealer.opinions?.badges.badge,
                    opinions: offer.dealer.opinions,
                    producer: offer.dealer.producer,
                    shippings: offer.dealer.shippings
                }}
                badges={{
                    fastPayment: Boolean(fastPayment),
                    isQuality: offer.dealer.opinions?.badges.qsign,
                    isOpineoQuality: offer.dealer.opinions?.badges.credibilityVerification,
                    inPost: Boolean(inPost),
                    freeDelivery,
                    delivery24: Boolean(delivery24h),
                    promoText: promoText?.content
                }}
                price={offer.price}
                image={offer.photo.src}
                title={offer.description}
                rates={rates}
                opinions={offer.dealer.opinions}
                variantsCount={offer.variants ? offer.variants.length : 0}
                isOpen={isOpenVariants}
                toggleOpenVariants={onToggleOpenVariants}
                starsSize={'xs'}
                availability={offer.availability}
            />

            {offer.variants && offer.variants.length > 0 && (
                <div className={classNames({
                    'offer-wrapper-variants-count': true,
                    'active': isOpenVariants
                })}
                >
                    {flectionNumeral(offer.variants.length, ['wariant', 'warianty', 'wariantów'])}
                </div>
            )}

            <div className={classNames({
                'offer-wrapper-variants': true,
                'offer-wrapper-variants--expanded': isOpenVariants
            })}
            >
                {offer.variants && offer.variants.length > 0 && offer.variants.map(variant => (
                    <ProductOffer
                        id={offer.id}
                        shopUrl={variant.url}
                        key={variant.id}
                        price={variant.price}
                        rates={rates}
                        title={variant.description}
                        image={variant.photo.src}
                        dealer={{
                            id: offer.dealer.id,
                            logo: offer.dealer.logo,
                            name: variant.dealer.name,
                            authorized: variant.dealer.authorized,
                            opinions: variant.dealer.opinions,
                            producer: variant.dealer.producer,
                            shippings: offer.dealer.shippings
                        }}
                        badges={{
                            fastPayment: Boolean(fastPayment),
                            isQuality: variant.dealer.opinions?.badges.qsign,
                            isOpineoQuality: offer.dealer.opinions?.badges.credibilityVerification,
                            inPost: Boolean(inPost),
                            freeDelivery,
                            delivery24: Boolean(delivery24h)
                        }}
                        opinions={variant.dealer.opinions}
                        toggleOpenVariants={onToggleOpenVariants}
                        starsSize={'xs'}
                        availability={offer.availability}
                    />
                ))}
            </div>
        </div>
    );
};

export default ProductOfferWrapper;
